import { useQuery } from 'react-query';
import { ServerStateKeysEnum } from 'reactQuery/constants';
import { dsoTaxonService } from 'services';

export const useRetriveDsoAllTaxonDetails = () => {
  return useQuery(
    ServerStateKeysEnum.dsoTaxons,
    () => dsoTaxonService.getTaxonDetails(),
    { staleTime: Infinity }
  );
};
